import React from "react";
import { CONTESTS } from "../shared/constants";
import { pluralize , intComma } from "humanize-plus";

interface ContestStats {
  cyclocross: number;
  "spring-classics": number;
  "tour-de-france": number;
  "vuelta-a-espana": number;
  "giro-d-italia": number;
  worlds: number;
  other: number;
}

const PlayerContestChart = ({
  results,
  rois,
}: {
  results: ContestStats;
  rois: ContestStats;
}) => {
  const shouldDisplay =
    CONTESTS.map((contest) => results[contest.slug]).filter(
      (count) => count !== 0
    ).length > 1;

  if (!shouldDisplay) {
    return null;
  }

  const maxResult = Math.max(
    ...(CONTESTS.map((contest) => Math.abs(results[contest.slug])))
  );
  const maxRoi = Math.max(
    ...(CONTESTS.map((contest) => Math.abs(rois[contest.slug])))
  );

  return (
    <div className="player__row">
      <div className="player__col--100">
        <h2 className="player__label">Contest Performance</h2>

        {CONTESTS.map((contest) => {
          const result = results[contest.slug];
          const roi = rois[contest.slug];
          if (result === 0) {
            return null;
          }
          return (
            <div className="player-contest" key={contest.name}>
              <h3 className="player__label--sub player__label--center">
                {contest.name}
              </h3>
              <div
                className={`player-contest-bar__outer ${
                  result > 0
                    ? "player-contest-bar__outer--gain"
                    : "player-contest-bar__outer--loss"
                }`}
              >
                <div className="player-contest-bar__label player__result-chart-label">
                  {intComma(result)} {pluralize(result, "point")}
                </div>
                <div
                  className="player-contest-bar__bar"
                  style={{ width: `${(Math.abs(result) / maxResult) * 50}%` }}
                ></div>
              </div>

              <div
                className={`player-contest-bar__outer
                player-contest-bar__outer--roi
                ${
                  roi > 0
                    ? "player-contest-bar__outer--gain"
                    : "player-contest-bar__outer--loss"
                }`}
              >
                <div className="player-contest-bar__label player__result-chart-label">
                  {Math.round(roi)}% ROI
                </div>
                <div
                  className="player-contest-bar__bar"
                  style={{ width: `${(Math.abs(roi) / maxRoi) * 50}%` }}
                ></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlayerContestChart;
